import React, { useState, useEffect } from "react";
import {
  ArrowUpRightIcon,
  ArrowDownRightIcon,
  AlertTriangleIcon,
} from "lucide-react";
import "./styles.css";
import { SensorDataProps } from "../../controller/tankController";
import { GiFuelTank } from "react-icons/gi";
import AverageCard from "../AverageCard";
import { FaRegCalendarAlt, FaSignal } from "react-icons/fa";
import { GrLocation } from "react-icons/gr";

interface TankVisualizerProps {
  currentLevel: number;
  history: SensorDataProps[];
  prevLevel: number;
  address: string | null;
  tankOrientation?: string;
  lastUpdated?: string;
  signal?: string;
}

const TankVisualizer: React.FC<TankVisualizerProps> = ({
  currentLevel,
  history = [],
  address,
  ...props
}) => {
  const [prevLevel, setPrevLevel] = useState(currentLevel);
  const [isIncreasing, setIsIncreasing] = useState(false);

  useEffect(() => {
    if (currentLevel !== prevLevel) {
      setIsIncreasing(currentLevel > prevLevel);
      setPrevLevel(currentLevel);
      console.log("isIncreasing: ", isIncreasing);
    }
  }, [currentLevel, prevLevel]);

  const calculateTrend = () => {
    if (history.length < 2) return 0;
    return currentLevel - prevLevel;
  };

  const trend = calculateTrend();

  const TANK_HEIGHT = 110.3;
  const RADIUS = 38.3;
  const TOTAL_VOLUME = Math.PI * RADIUS * RADIUS * TANK_HEIGHT;
  const currentHeight = (currentLevel / 100) * TANK_HEIGHT;
  const currentVolume = (
    (Math.PI * Math.pow(RADIUS, 2) * currentHeight) /
    1000
  ).toFixed(1);

  const cylinderFillStyle = {
    position: "absolute" as const,
    bottom: 0,
    width: "100%",
    height: `${currentLevel}%`,
    backgroundColor: currentLevel < 20 ? "#ff5b5b" : "#007bff",
    left: 0,
    transition: "height 0.5s ease-in-out, background-color 0.5s ease-in-out",
  };

  return (
    <div className="tank-wrap">
      <div className="tank-visualization-cont">
        <div className="tank-visualization-left">
          {currentLevel < 20 && (
            <div className="tank-header">
              <h2>Diesel Tank</h2>
              <div className="alert-container">
                <div className="alert-message">
                  <AlertTriangleIcon size={16} />
                  <span>Low Level</span>
                </div>
              </div>
            </div>
          )}
          <div className="card">
            <div className="tank-content">
              <div className="cylinder">
                <div className="cylinder-fill" style={cylinderFillStyle}></div>
              </div>
              <div className="percentage-scale">
                <span>100%</span>
                <span>80%</span>
                <span>60%</span>
                <span>40%</span>
                <span>20%</span>
                <span>0%</span>
              </div>
            </div>
            <div className="cylinder-base"></div>
            <div className="tank-location">Location: {address}</div>
          </div>
          {/* <div className="stat-card-cont">
            <div className="stat-card full-width">
              <p className="stat-label">Trend</p>
              <div className="trend-container">
                <p className="trend-value">{Math.abs(trend).toFixed(1)}%</p>
                {trend > 0 ? (
                  <div className="trend-indicator increasing">
                    <ArrowUpRightIcon size={16} />
                    <span>Increasing</span>
                  </div>
                ) : trend < 0 ? (
                  <div className="trend-indicator decreasing">
                    <ArrowDownRightIcon size={16} />
                    <span>Decreasing</span>
                  </div>
                ) : (
                  <span className="trend-indicator stable">Stable</span>
                )}
              </div>
            </div>
          </div> */}
        </div>
        <div className="tank-visualization-right">
          <AverageCard
            title="Tank Orientation"
            value={props.tankOrientation}
            icon={<GiFuelTank size={24} color="#2f6ccd" />}
          />
          <AverageCard
            title="Signal"
            value={props.signal}
            icon={<FaSignal size={24} color="#2f6ccd" />}
          />
          <AverageCard
            title="Location"
            value={address!}
            icon={<GrLocation size={24} color="#2f6ccd" />}
          />
          <AverageCard
            title="Last updated"
            value={props.lastUpdated}
            icon={<FaRegCalendarAlt size={24} color="#2f6ccd" />}
          />
        </div>
      </div>
    </div>
  );
};

export default TankVisualizer;
